const Images = {
  appIcon: require("../assets/images/stressBallIcon.png"),
  downloadButtonApple: require("../assets/images/downloadAppApple.png"),
  downloadButtonGoogle: require("../assets/images/downloadAppGoogle.png"),
  appScreenshots: require("../assets/images/appScreenshots.png"),
  backgroundImage: require("../assets/images/backgroundImage.png"),
};

export default Images;
